import React from 'react';
import { BasicViewHeader } from '../../components';

export const MainHeader = () => (
  <BasicViewHeader
    header="Rockerbox Performance"
    subheader="Compare platform-reported metrics to Rockerbox performance metrics"
  />
);
